import { COLOR_WHITE } from "../../THEME_BASE";
const paginationColors = (colors) => ({
  active: {
    background: colors.info[5],
    border: colors.info[5],
    color: COLOR_WHITE
  }
});
export default paginationColors;
